// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const In: React.FC = () => {
    return <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-746.000000, -417.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(654.000000, 175.000000)" id="UI-Icon/in">
                    <path d="M29,21.1964881 L29,27 L25.5706819,27 L25.5706819,21.5851723 C25.5706819,20.2249235 25.0746681,19.2966068 23.8333686,19.2966068 C22.8857939,19.2966068 22.3218915,19.9222242 22.0738101,20.5274038 C21.9833417,20.7437531 21.9600551,21.044883 21.9600551,21.3477282 L21.9600551,27 L18.5295838,27 C18.5295838,27 18.5757852,17.8290592 18.5295838,16.8788814 L21.9597203,16.8788814 L21.9597203,18.3135094 C21.952764,18.3242393 21.9437246,18.3358086 21.9371776,18.34621 L21.9597203,18.34621 L21.9597203,18.3135094 C22.4154474,17.6248631 23.2293283,16.6411088 25.0510466,16.6411088 C27.3080325,16.6411088 29,18.0876711 29,21.1964881 Z M14.9411648,12 C13.7676051,12 13,12.7552153 13,13.7483492 C13,14.7198408 13.7453972,15.4979757 14.895633,15.4979757 L14.9185477,15.4979757 C16.1148362,15.4979757 16.8588198,14.7199868 16.8588198,13.7483492 C16.8362771,12.7552153 16.1148362,12 14.9411648,12 Z M13.2037399,27 L16.6329092,27 L16.6329092,16.8788814 L13.2037399,16.8788814 L13.2037399,27 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(In);
